import { handleActions } from "redux-actions";
import { TEMPLATE, TEMPLATES, SCOPE_BRAND_SET } from "constants/action-types";
import ITemplate, { ITemplatePreview } from "constants/template-types";
import { fetchActions, initialBaseState, updateActions, IFetchStoreState } from "./base-reducers";

export const templates = handleActions<IFetchStoreState<ITemplatePreview[]>>(
    {
        ...fetchActions(TEMPLATES.FETCH),
        ...updateActions(TEMPLATES),
        [SCOPE_BRAND_SET]: () => initialBaseState,
    },
    initialBaseState
);

export const template = handleActions<IFetchStoreState<ITemplate>>(
    {
        ...fetchActions(TEMPLATE.FETCH),
        ...updateActions(TEMPLATE),
        [SCOPE_BRAND_SET]: () => initialBaseState,
    },
    initialBaseState
);
